import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/error_outline.png'


const _hoisted_1 = { class: "delete-order-content" }
const _hoisted_2 = { class: "delete-order-content__title" }
const _hoisted_3 = { class: "delete-order-content__description" }
const _hoisted_4 = { class: "delete-order-content__button-container button-container" }

import { i18n } from '@/i18n';
import { ref, watch } from 'vue';
import Modal from '@/components/modal/Modal.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'NormalOrderDeleteModal',
  props: {
    modalState: { type: Boolean, default: false }
  },
  emits: ["canceled", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// emits
const emits = __emit;

//変数
const t = i18n.t;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    class: "confirm-modal-container",
    "modal-size": 'max-content',
    "modal-width": 500,
    "aspect-ratio": true,
    "stretch-container": true,
    "scroll-off": true,
    padding: '16px',
    "modal-state": _ctx.modalState,
    "border-radius": '16px'
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("img", {
          class: "delete-order-content__icon",
          src: _imports_0
        }, null, -1)),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('選択した発注を削除しますか？')), 1),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('削除した発注の復元はできません。')), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(TextButton, {
            "button-style": 'btn-secondary-error',
            size: 'btn-md',
            "on-click": () => emits('canceled'),
            class: "button-container--cancel-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('キャンセル')), 1)
            ], undefined, true),
            _: 1
          }, 8, ["on-click"]),
          _createVNode(TextButton, {
            "button-style": 'btn-error',
            size: 'btn-md',
            "on-click": () => emits('confirm'),
            class: "button-container--confirm-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('削除')), 1)
            ], undefined, true),
            _: 1
          }, 8, ["on-click"])
        ])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state"]))
}
}

})